import clsx from 'clsx'
import Button from 'lib/button'
import React from 'react'
import UserDetail from './user'
import NodeSelect from './node-select'
import Fetch from 'lib/fetch'
import useSWR from 'swr'
import Fetcher from 'lib/fetcher'

const NodeNew = ({ model }) => {
  const { data: _nodes, mutate } = useSWR('nodes', Fetcher)

  const addPermissions = () => {
    model.saving = true
    return Fetch(model.permissionsUrl, {
      method: 'POST',
      body: JSON.stringify({
        permissions: model.permissionsPayload,
      }),
    }).then((response) => {
      if (response.ok) {
        model.reset()
        mutate()
      } else {
        response.json().then((data) => alert(`Error: ${data.errors}`))
      }
    })
  }

  return (
    <div className="flex flex-col space-y-2 my-2 rounded border border-x-mimic-light-brown">
      <div className="px-3 py-2 bg-mimic-light-brown font-semibold">
        Add a new node/permitted user
      </div>
      <div className="flex flex-col space-y-1 p-2">
        <UserDetail model={model} />
        <NodeSelect model={model} />
      </div>
      <div className="flex items-center p-2">
        <Button
          onClick={model.cancel}
          className={clsx(
            'bg-mimic-white border border-mimic-black !text-mimic-black'
          )}
          label="Cancel"
        />
        <Button
          disabled={!model.hasChanges}
          label="Add"
          className="ml-auto disabled:opaciyt-50"
          onClick={addPermissions}
        />
      </div>
    </div>
  )
}

export default NodeNew
